import React from 'react';

const SvgCheckedbox: React.FC<React.SVGProps<SVGSVGElement>> = (
  props: React.SVGProps<SVGSVGElement>,
) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" {...props}>
      <defs>
        <linearGradient
          id="checkedbox_svg__a"
          x1={0.5}
          x2={0.5}
          y2={1}
          gradientUnits="objectBoundingBox"
        >
          <stop offset={0} stopColor="#ec775d" />
          <stop offset={1} stopColor="#ff8da7" />
        </linearGradient>
      </defs>
      <g transform="translate(-255 -840)">
        <rect
          width={20}
          height={20}
          fill="url(#checkedbox_svg__a)"
          rx={3}
          transform="translate(255 840)"
        />
        <path
          strokeLinecap="round"
          stroke="#fff"
          d="M259.055 850.739l3.8 3.8 9.06-9.061"
        />
      </g>
    </svg>
  );
};

export default SvgCheckedbox;
